import { render, staticRenderFns } from "./UserNavbar.vue?vue&type=template&id=b382d76e&scoped=true"
import script from "./UserNavbar.vue?vue&type=script&lang=js"
export * from "./UserNavbar.vue?vue&type=script&lang=js"
import style0 from "./UserNavbar.vue?vue&type=style&index=0&id=b382d76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b382d76e",
  null
  
)

export default component.exports